"use client"

import { Tabs } from 'nextra/components'
import Image from 'next/image'
import {createContext, useContext, useState, useEffect} from 'react'

const TabContext = createContext({
  selectedIndex: 0,
  setSelectedIndex: (index: number) => {},
})

export const TabProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  useEffect(() => {
    const { userAgent } = window.navigator;
    const macos = /(macintosh|macintel|macppc|mac68k|macos)/i.test(userAgent.toLowerCase());
    const windows = /(win32|win64|windows|wince)/i.test(userAgent.toLowerCase());
    const linux = /linux/i.test(userAgent.toLowerCase());
    const initialIndex = macos ? 0 : windows ? 1 : linux ? 2 : 0;
    setSelectedIndex(initialIndex);
  }, []);

  return (
    <TabContext.Provider value={{ selectedIndex, setSelectedIndex }}>
      {children}
    </TabContext.Provider>
  )
}

export const SyncedTabs = ({ items, children }: { items: string[], children: React.ReactNode }) => {
  const { selectedIndex, setSelectedIndex } = useContext(TabContext)
  return (
    <Tabs items={items} selectedIndex={selectedIndex} onChange={setSelectedIndex}>
      {children}
    </Tabs>
  )
}

export function AndroidScreen({ environment }: { environment: 'macos' | 'windows' | 'linux' }) {
  let imageSrc;
  switch (environment) {
    case 'macos':
      imageSrc = '/images/android-screen-macos.webp';
      break;
    case 'windows':
      imageSrc = '/images/android-screen-windows.webp';
      break;
    case 'linux':
      imageSrc = '/images/android-screen-linux.webp';
      break;
    default:
      imageSrc = '/images/android-screen-macos.webp';
      console.warn(`Unsupported environment for AndroidScreen image source: ${environment}`);
  }
  return (
    <div className="flex justify-center py-8">
      <Image
        src={imageSrc}
        alt="Remote Android via Limbar"
        width={500}
        height={500}
        className="rounded-lg shadow-lg"
      />
    </div>
  )
} 